// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c7ca2d0","732":"dc963a5b","977":"47c39ea6"}[chunkId] + ".chunk.js";
};